// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as _ from "lodash";
import * as React from "react";
import { Grid } from "semantic-ui-react";
import DashboardGridCell from "../DashboardGridCell";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DashboardGridView = props => {
  const {
    widgets,
    onCreate,
    onDelete
  } = props;
  return /*#__PURE__*/_jsx(Grid, {
    "data-sentry-element": "Grid",
    "data-sentry-component": "DashboardGridView",
    "data-sentry-source-file": "DashboardGridView4.tsx",
    children: /*#__PURE__*/_jsxs(Grid.Row, {
      stretched: true,
      columns: 2,
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "DashboardGridView4.tsx",
      children: [/*#__PURE__*/_jsx(Grid.Column, {
        "data-sentry-element": "unknown",
        "data-sentry-source-file": "DashboardGridView4.tsx",
        children: /*#__PURE__*/_jsx(DashboardGridCell, {
          view: 5,
          position: 1,
          widget: _.find(widgets, {
            position: 1
          }),
          onCreate: onCreate,
          onDelete: onDelete,
          "data-sentry-element": "DashboardGridCell",
          "data-sentry-source-file": "DashboardGridView4.tsx"
        })
      }), /*#__PURE__*/_jsx(Grid.Column, {
        "data-sentry-element": "unknown",
        "data-sentry-source-file": "DashboardGridView4.tsx",
        children: /*#__PURE__*/_jsx(DashboardGridCell, {
          view: 5,
          position: 2,
          widget: _.find(widgets, {
            position: 2
          }),
          onCreate: onCreate,
          onDelete: onDelete,
          "data-sentry-element": "DashboardGridCell",
          "data-sentry-source-file": "DashboardGridView4.tsx"
        })
      })]
    })
  });
};
DashboardGridView.cells = 2;
export default DashboardGridView;